export const EMAIL_INVALID='Email is Invalid'
export const PASSWORD_ERROR ="Passwords must be 8 characters in length with at least 1 upper case, numeric, and special character";